const runModalSizes = () => {
  const modal = document.getElementById("quick-add-modal");
  const overlay = modal.querySelector(".modal__overlay");
  const closeBtn = modal.querySelector(".modal__header-close");

  const openModal = () => {
    modal.setAttribute("open", "true");
  };

  const closeModal = () => {
    modal.removeAttribute("open");
    modal.dataset.selectedColor = "";
    const modalBody = modal.querySelector(".modal__body");
    modalBody.innerHTML = "";
  };

  overlay?.addEventListener("click", closeModal);
  closeBtn?.addEventListener("click", closeModal);

  document.querySelectorAll(".btn-modal-quick-add").forEach((button) => {
    button.addEventListener("click", () => {
      const card = button.closest(".product-card-wrapper");
      const script = card?.querySelector(
        ".card__button .qa-product-variants-json"
      );
      if (!script) return;

      try {
        const variants = JSON.parse(script.textContent);
        if (!Array.isArray(variants)) throw new Error("Invalid variants");

        const productIdElement = card?.querySelector(
          '.card__button [id^="quick-add-mobile-quantity-"]'
        );
        const match = productIdElement?.id?.match(
          /quick-add-mobile-quantity-(\d+)/
        );
        const currentProductId = match ? match[1] : null;

        const selectedColorInput = card.querySelector(
          ".color-swatches input[data-color]:checked"
        );
        const selectedColor = selectedColorInput?.value.trim();

        modal.dataset.selectedColor = selectedColor;

        const product = {
          id: currentProductId,
          variants,
          selected_or_first_available_variant:
            variants.find((v) => v.available) || variants[0],
        };

        openModal();
        updateModalContent(product);
        updateModalSizesAvailability(selectedColor);
      } catch (e) {
        console.error("Error processing product variants: ", e);
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  runModalSizes();
});

const updateModalContent = (product) => {
  const modalBody = document.querySelector(
    "#quick-add-modal .modal__board .modal__body"
  );
  if (!modalBody || !product || !product.variants) return;

  const productId = product.id;
  const formId = `quick-add-form-${productId}`;
  const buttonId = `cta-quick-add-${productId}`;

  const seenSizes = new Set();
  let count = 0;
  const maxSizes = 10;

  let sizesHTML = `<ul class="size-selector" id="sizes-${productId}">`;

  product.variants.forEach((variant) => {
    const size = variant.option2;
    if (!size || seenSizes.has(size)) return;
    if (count >= maxSizes) return;

    seenSizes.add(size);
    count++;

    const inputId = `size-${productId}-${count}`;
    const unavailableClass = variant.available ? "" : " size-selector__checked";

    sizesHTML += `
      <li class="size-selector__item${unavailableClass}">
        <label class="size-selector__label" for="${inputId}">
          <input
            type="radio"
            id="${inputId}"
            name="size-${productId}"
            value="${size}"
            class="size-selector__input"
            data-color="${variant.option1}"
            data-option-value-id="${variant.id}"
            data-available="${variant.available}"
          > ${size}
        </label>
      </li>
    `;
  });

  sizesHTML += `</ul>`;

  const isAvailable = product.selected_or_first_available_variant?.available;
  const buttonLabel = isAvailable ? "Quick Add" : "Sold Out";

  const formHTML = `
    <form 
      method="post"
      id="${formId}"
      class="form-quick-add" 
      accept-charset="UTF-8" 
      enctype="multipart/form-data" 
      novalidate
      data-type="add-to-cart-form"
      data-hs-cf-bound="true"
    >
      ${sizesHTML}
      <button 
        type="submit"
        id="${buttonId}"
        name="${buttonId}"
        class="btn btn-cta-primary btn-modal-quick-add-js"
        role="quick-add-submit"
        disabled
      >
        <span class="btn-label">${buttonLabel}</span>
        <div class="loading__spinner hidden">
          <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
            <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
          </svg>
        </div>
      </button>
    </form>
  `;

  modalBody.innerHTML = formHTML;

  const script = document.createElement("script");
  script.className = "qa-product-variants-json";
  script.type = "application/json";
  script.textContent = JSON.stringify(product.variants);
  modalBody.appendChild(script);

  setModalFormListeners();
  setModalQuickAddButtons();
};

const setModalFormListeners = () => {
  const modal = document.getElementById("quick-add-modal");
  if (!modal) return;

  const forms = modal.querySelectorAll(".modal__body form");
  if (!forms) return;

  forms.forEach((form) => {
    const submitButton = form.querySelector('[type="submit"]');
    const variantSizes = form.querySelectorAll(
      'input[type="radio"][data-option-value-id]'
    );

    const checked = [...variantSizes].some((r) => r.checked);
    if (submitButton) {
      submitButton.disabled = !checked;
    }

    variantSizes.forEach((sizeInput) => {
      sizeInput.addEventListener("change", () => {
        const selected = form.querySelector(
          'input[type="radio"][data-option-value-id]:checked'
        );

        if (submitButton) {
          submitButton.disabled = !selected;
        }

        variantSizes.forEach((input) => {
          const label = input.closest("label");
          if (label) label.classList.remove("size-selector__checked");
        });

        if (selected) {
          const selectedLabel = selected.closest("label");
          if (selectedLabel)
            selectedLabel.classList.add("size-selector__checked");
        }
      });
    });
  });
};

const setModalQuickAddButtons = () => {
  const btnsModalQuickAdd = document.querySelectorAll(
    ".modal__body .btn-modal-quick-add-js"
  );

  btnsModalQuickAdd.forEach((btn) => {
    btn.addEventListener("click", async (event) => {
      event.preventDefault();

      btn.classList.add("loading");

      const modal = btn.closest("#quick-add-modal");
      if (!modal) {
        console.warn("Modal not found");
        btn.classList.remove("loading");
        return;
      }

      const variantsJson = modal.querySelector(".qa-product-variants-json");
      const selectedSizeInput = modal.querySelector(
        "input[data-option-value-id]:checked"
      );
      if (!variantsJson || !selectedSizeInput) {
        console.warn("Color or size not selected");
        btn.classList.remove("loading");
        return;
      }

      const selectedColor = modal.dataset.selectedColor?.trim() || "";
      const selectedSize = selectedSizeInput?.value.trim();
      const variantTitle = `${selectedColor} / ${selectedSize}`
        .trim()
        .normalize();

      const variants = JSON.parse(variantsJson.textContent);
      const matchedVariant = variants.find(
        (variant) => variant.title.trim().normalize() === variantTitle
      );

      if (!matchedVariant) {
        console.warn("No matching variant found for:", variantTitle);
        btn.classList.remove("loading");
        return;
      }

      const formData = {
        items: [
          {
            id: matchedVariant.id,
            quantity: 1,
          },
        ],
      };

      try {
        const addResp = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          }
        ).then((res) => res.json());

        const sectionHTML = await fetch(
          `${window.Shopify.routes.root}?sections=cart-notification-product,cart-notification-button,cart-icon-bubble`
        ).then((res) => res.json());

        modal.removeAttribute("open");
        modal.dataset.selectedColor = "";

        const modalBody = modal.querySelector(".modal__body");
        modalBody.innerHTML = "";

        const cartNotif = document.querySelector("cart-notification");
        cartNotif?.renderContents({
          key: addResp.key,
          sections: sectionHTML,
        });
      } catch (error) {
        console.error("Error adding to cart: ", error);
      } finally {
        btn.classList.remove("loading");
      }
    });
  });
};

if (!window.updateModalSizesAvailability) {
  window.updateModalSizesAvailability = (selectedColor) => {
    const modal = document.getElementById("quick-add-modal");
    const modalBody = modal.querySelector(".modal__body");
    if (!modal || !modalBody) return;

    const sizeList = modalBody.querySelector(`[id^="sizes-"]`);
    const variantsDataScript = modalBody.querySelector(
      ".qa-product-variants-json"
    );

    if (!sizeList || !variantsDataScript) return;

    let allVariants;
    try {
      allVariants = JSON.parse(variantsDataScript.textContent);
    } catch (error) {
      return;
    }

    if (!Array.isArray(allVariants)) return;

    const sizeItems = sizeList.querySelectorAll("li");

    sizeItems.forEach((li) => {
      const sizeInput = li.querySelector('input[type="radio"]');
      if (!sizeInput) return;

      const label = sizeInput.closest("label");
      const inputSize = (sizeInput.value || "").trim();
      const matchingVariant = allVariants.find(
        (v) =>
          v.option1 &&
          v.option1.toLowerCase() === selectedColor.toLowerCase() &&
          v.option2 === inputSize
      );

      const isAvailable = matchingVariant && matchingVariant.available;

      if (!isAvailable) {
        li.classList.add("size-selector__item--unavailable");
        sizeInput.disabled = true;
        sizeInput.checked = false;

        if (label) label.classList.remove("size-selector__checked");
      } else {
        li.classList.remove("size-selector__item--unavailable");
        sizeInput.disabled = false;
      }
    });
  };
}

window.runModalSizes = runModalSizes;
window.updateModalContent = updateModalContent;
window.setModalFormListeners = setModalFormListeners;
window.setModalQuickAddButtons = setModalQuickAddButtons;
